const ICON_ACTION_LABELS = {
    'pi-angle-left': 'Previous',
    'pi-arrow-left': 'Back',
    'pi-arrow-right': 'Next',
    'pi-arrows-alt': 'Move',
    'pi-bars': 'Open menu',
    'pi-bell': 'Notifications',
    'pi-calendar': 'Choose date',
    'pi-chart-bar': 'View chart',
    'pi-check': 'Confirm',
    'pi-chevron-left': 'Previous',
    'pi-chevron-right': 'Next',
    'pi-cog': 'Settings',
    'pi-copy': 'Copy',
    'pi-download': 'Download',
    'pi-ellipsis-h': 'More actions',
    'pi-ellipsis-v': 'More actions',
    'pi-eye': 'View details',
    'pi-file-excel': 'Export spreadsheet',
    'pi-filter': 'Filter',
    'pi-home': 'Home',
    'pi-info-circle': 'Information',
    'pi-list': 'List view',
    'pi-lock': 'Lock',
    'pi-pause': 'Pause',
    'pi-pencil': 'Edit',
    'pi-play': 'Play',
    'pi-plus': 'Add',
    'pi-print': 'Print',
    'pi-question-circle': 'Help',
    'pi-refresh': 'Refresh',
    'pi-replay': 'Reset',
    'pi-search-minus': 'Zoom out',
    'pi-search-plus': 'Zoom in',
    'pi-send': 'Submit',
    'pi-sitemap': 'View hierarchy',
    'pi-sort-alt': 'Sort',
    'pi-star': 'Favorite',
    'pi-th-large': 'Grid view',
    'pi-times': 'Close',
    'pi-trash': 'Delete',
    'pi-upload': 'Upload',
    'pi-user': 'User details',
    'pi-window-maximize': 'Open in full screen'
};

export const inferIconActionLabel = (icon = '') => {
    const iconClass = Object.keys(ICON_ACTION_LABELS).find((className) => icon.includes(className));
    return iconClass ? ICON_ACTION_LABELS[iconClass] : 'Action';
};

export const primeVueButtonPassThrough = {
    root: ({ props, instance }) => {
        const attrs = instance?.$attrs || {};
        const existingLabel = attrs['aria-label'] || attrs.ariaLabel || attrs['aria-labelledby'];

        if (existingLabel || props.label || !props.icon) return {};

        return { 'aria-label': attrs.title || inferIconActionLabel(props.icon) };
    }
};

const labelNativeIconButton = (button) => {
    if (!(button instanceof HTMLButtonElement)) return;
    if (button.hasAttribute('aria-label') || button.hasAttribute('aria-labelledby')) return;
    if (button.textContent?.trim()) return;

    const icon = button.querySelector('[class*="pi-"]');
    button.setAttribute('aria-label', button.title || inferIconActionLabel(icon?.className || ''));
};

export const installAccessibilityGuard = () => {
    document.querySelectorAll('button').forEach(labelNativeIconButton);

    const observer = new MutationObserver((mutations) => {
        mutations.forEach(({ addedNodes }) => {
            addedNodes.forEach((node) => {
                if (!(node instanceof Element)) return;
                if (node.matches('button')) labelNativeIconButton(node);
                node.querySelectorAll('button').forEach(labelNativeIconButton);
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
};
